export default function DragPreview() {
  return <div className="opacity-80 cursor-grabbing"></div>;
}
